import { notifications } from "@marketplace/ui/notifications";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { InvoiceService } from "@/services/invoice-service";
import type {
  RegenerateInvoiceRequestDto,
  RegenerateInvoiceResponseDto
} from "@/types";

type UsePostRegenerateInvoiceMutationParams = {
  options?: UseMutationOptions<
    RegenerateInvoiceResponseDto,
    unknown,
    RegenerateInvoiceRequestDto
  >;
};

export const usePostRegenerateInvoiceMutation = ({
  options
}: UsePostRegenerateInvoiceMutationParams = {}) => {
  const { t } = useTranslation("order", {
    keyPrefix: "transactionHistoryPage.notifications"
  });

  return useMutation({
    mutationFn: async (payload) => {
      return await InvoiceService.regenerateInvoice({ payload });
    },
    ...options,
    onError: (...errorArgs) => {
      notifications.show({
        message: t("regenerateInvoiceError"),
        variant: "error"
      });
      options?.onError?.(...errorArgs);
    }
  });
};
